import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "assets/svgIcons/CloseIcon";
import { AddImageContainer } from "pages/FoodAndBeverages/FBSettings/FoodAndBeveragesStyled";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import React, { useEffect } from "react";
import { useHookstate } from "@hookstate/core";
import {
    API_CALLS
} from "redux/reduxToolkitServices/_commonApiCalls/api";
const FoodImagePopup = ({
    open,
    setImage,
    setOpen,
    openSubChild,
    subChildIndex,
    setChildListImage,
    setSubChildIndexImg,
    title
}) => {

    const { getFoodImageNameDataState } =
        useSelector((state) => state.commonReducers) || [];
    const handleClose = () => {
        if (subChildIndex !== undefined) {
            openSubChild[subChildIndex] = false;
            setOpen([...openSubChild]);
        } else setOpen(false);
    };
    const [foodImage, setFoodImage] = React.useState([]);
    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
    const {dispatch} = useDispatch();
    const { t } = useTranslation();

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        maxWidth: "1000px",
        bgcolor: "background.paper",
        boxShadow: 24,
        borderRadius: "5px",
        //   p: 4,
    };

    const selectImage = (e, img) => {
        e.stopPropagation();
        let updatedImage = [];
        if (subChildIndex !== undefined) {
            setChildListImage(img.key);
            setSubChildIndexImg(subChildIndex);
        } else {
            updatedImage.push(img);
            setImage(updatedImage);
        }

        if (subChildIndex !== undefined) {
            openSubChild[subChildIndex] = false;
            setOpen([...openSubChild]);
        } else setOpen(false);
    };
    useEffect(() => {
        getFoodImageNameDataState &&
            getFoodImageNameDataState.length > 0 &&
            getFoodImageNameDataState?.map(async (item, index) => {
                let img;
                try {
                    img = require("../../../assets/images/FoodImages/" + item)
                    setFoodImage((prevImages) => [...prevImages, { key: item, value: img }]);
                }
                catch (e) {
                    if(item){
                    await API_CALLS.getFoodImageApiCall(
                        headersConfigData,
                        siteId.get(),
                        item
                    )
                        .then(async (response) => {
                            const blob = await response.blob();  // Handle image as a blob
                            const img = URL.createObjectURL(blob);
                            setFoodImage((prevVal) => [...prevVal, { key: item, value: img }])
                        }
                        );
                    }
                }
            }
            )
    }, [dispatch]);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <AddImageContainer>
                    <div className="header">
                        <h4>
                            {t("Select_image_for")} {title}
                        </h4>
                        <div className="action-wrapper">
                            <button onClick={(e) => selectImage(e, "")}>
                                {t("Select_No_Image")}
                            </button>
                            <CloseIcon
                                onClick={handleClose}
                                color="#fff"
                                width={15}
                                height={15}
                            />
                        </div>
                    </div>
                    <div className="images-container">
                        {foodImage &&
                            foodImage.length > 0 &&
                            foodImage?.map((item, index) => {

                                return (
                                    <div key={`${item}_${index}`}>
                                        <img
                                            src={item.value}
                                            alt="Sandwitch-image"
                                            onClick={(e) => selectImage(e, item)}
                                        />
                                    </div>
                                );
                            }
                            )}
                    </div>
                </AddImageContainer>
            </Box>
        </Modal>
    );
};

export default FoodImagePopup;


